import lazysizes from "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/respimg/ls.respimg";
import Init from "./common/Init";

import CarouselController from "./controllers/CarouselController";
import HeaderController from "./controllers/HeaderController";
import NavigationController from "./controllers/NavigationController";
import PostResetTimeController from "./controllers/PostResetTimeController";
import PostAuctionController from "./controllers/PostAuctionController";
import PostsManagerController from "./controllers/PostsManagerController";
import listCategoryController from "./controllers/listCategoryController";
import ViewOnlineController from "./controllers/ViewOnlineController";
import SearchController from "./controllers/SearchController";
import PostAnonymousAuctionController from "./controllers/PostAnonymousAuctionController";
import PostAuctionRequestController from "./controllers/PostAuctionRequestController";
import PopupController from "./controllers/PopupController";
import NotificationDropdownController from "./controllers/NotificationDropdownController";
import ContactFormController from "./controllers/ContactFormController";
import AuctionGuideController from "./controllers/AuctionGuideController";
import ShareButtonsController from "./controllers/ShareButtonsController";
import SeoArticlesLoaderController from "./controllers/SeoArticlesLoaderController";
import PostViewTrackerController from "./controllers/PostViewTrackerController";
import ArticleViewTrackerController from "./controllers/ArticleViewTrackerController";
import GuideVideoController from "./controllers/GuideVideoController";

new Init({
    // add code
    carousel: CarouselController,
    header: HeaderController,
    navigation: NavigationController,
    postresettime: PostResetTimeController,
    PostAuction: PostAuctionController,
    PostsManager: PostsManagerController,
    listCategory: listCategoryController,
    viewOnline: ViewOnlineController,
    search: SearchController,
    PostAnonymousAuction: PostAnonymousAuctionController,
    PostAuctionRequest: PostAuctionRequestController,
    Popup: PopupController,
    NotificationDropdown: NotificationDropdownController,
    ContactForm: ContactFormController,
    AuctionGuide: AuctionGuideController,
    ShareButtons: ShareButtonsController,
    SeoArticlesLoader: SeoArticlesLoaderController,
    PostViewTracker: PostViewTrackerController,
    ArticleViewTracker: ArticleViewTrackerController,
    GuideVideo: GuideVideoController
});

(() => {
    lazysizes.cfg.lazyClass = "js-lazyload";
    lazysizes.cfg.hFac = 0;
    document.addEventListener("lazybeforesizes", (e: any) => {
        e.detail.width = e.target.clientWidth || e.target.parentElement.clientWidth || e.detail.width;
    });
})();
